import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'

export class ToggleRelativeTime {
  static readonly type = '[RelativeTime] Toggle'
}

@State({
  name: 'relativeTime',
  defaults: {
    relative: true,
  },
})
@Injectable()
export class RelativeTimeState {
  @Selector()
  static isRelative(state: { relative: boolean }): boolean {
    return state.relative
  }

  @Action(ToggleRelativeTime)
  toggleRelativeTime(ctx: StateContext<{ relative: boolean }>): void {
    const state = ctx.getState()
    ctx.setState({
      ...state,
      relative: !state.relative,
    })
  }
}
